const router = [
  {
    name: 'traffic',
    path: '/traffic',
    meta: {
      title: '交通流量',
      icon: 'el-icon-data-line'
    }
  },
  {
    name: 'trafficsTatistics',
    path: '/traffic/statistics',
    component: () => import('/@/views/traffic/statistics.vue'),
    meta: { title: '车流量统计' }
  },
  {
    name: 'trafficPoints',
    path: '/traffic/points',
    component: () => import('/@/views/traffic/points.vue'),
    meta: { title: '点位管理' }
  },
  {
    name: 'trafficTime',
    path: '/traffic/time',
    component: () => import('/@/views/traffic/timeSlots.vue'),
    meta: { title: '时间段管理' }
  }
]
export default router
